// extracted by mini-css-extract-plugin
module.exports = {"CatalogRedirectSection":"lAVWF","CatalogRedirectSection_Text":"GGv7H","CatalogRedirectSection_Link":"ld38a"};